module.exports = __webpack_public_path__ + "img/flavor_pineapple.e39508ef.png";